import {
  Flex,
  Drawer,
  useDisclosure,
  Button,
  DrawerCloseButton,
  DrawerHeader,
  DrawerContent,
  DrawerOverlay,
  DrawerBody,
  DrawerFooter,
  Image,
  VStack,
  Text,
  Box,
  IconButton,
  Divider,
} from "@chakra-ui/react";
import { useRef, useEffect, useState } from "react";
import { visitorMenu, userMenu, practitionerMenuMobile } from "./menu";
import { IconChevronDown, IconMenuHamburger } from "../../../styles/icons";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import CustomAvatar from "../../components/common/CustomAvatar";

const NavBarMobile = ({ handleClick, loggedIn = false, handleLogout }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();
  const user = useSelector((state) => state.user);
  const [avatarImage, setAvatarImage] = useState("");
  const [getHelpMenu, setGetHelpMenu] = useState(false);
  const [articlesMenu, setArticlesMenu] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setAvatarImage(
      user?.userDetails?.therapistProfile?.profileImage
        ? user?.userDetails?.therapistProfile?.profileImage
        : user?.userDetails?.coachProfile?.profileImage
          ? user?.userDetails?.coachProfile?.profileImage
          : null
    );
  }, [user?.userDetails]);

  const showMenu = (arrMenu) => {
    return arrMenu.map((item, idx) => {
      if (!item.submenu) {
        return (
          <Button
            variant="menu"
            fontSize="sm"
            colorScheme="tertiary"
            leftIcon={item.leftIcon ? item.leftIcon : ""}
            aria-label={item.label}
            key={idx}
            onClick={() => {
              onClose();
              router.push(item.href);
            }}
          >
            <Text textStyle="body2">{item.label}</Text>
          </Button>
        );
      }
    });
  };

  const showMenuOptions = (data) => {
    return data.map((item, idx) => (
      <Button
        variant="menu"
        fontSize="sm"
        colorScheme="tertiary"
        leftIcon={item.leftIcon ? item.leftIcon : ""}
        aria-label={item.label}
        key={idx}
        onClick={() => {
          onClose();
          router.push(item.href);
        }}
      >
        <Text textStyle="footer2" color="brand.300">
          &nbsp;&nbsp;{item.label}
        </Text>
      </Button>
    ));
  };

  return (
    <Flex display={{ base: "flex", lg: "none" }}>
      {/* Menu Button */}

      {loggedIn ? (
        <Box paddingRight="8px">
          <CustomAvatar
            user={user.userDetails?.fullname}
            avatarImage={avatarImage}
            onClick={onOpen}
          />
        </Box>
      ) : (
        <IconButton
          aria-label="Menu"
          icon={<IconMenuHamburger size="32px" color="black" />}
          variant="menu"
          ref={btnRef}
          onClick={onOpen}
        />
      )}

      {/* Drawer Component */}
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Image
              width={{ base: "150px", lg: "247px" }}
              height={{ base: "28px", lg: "46px" }}
              src="/images/homepage/wd-logo.png"
              alt="welldoing logo"
            />
          </DrawerHeader>

          <DrawerBody borderTopWidth="1px">
            {/* Logged in Nav Items*/}
            {/* Visitor Nav Items*/}
            <VStack as="nav" spacing="1" align="flex-start">
              <Box></Box>
              {loggedIn && user.userDetails?.accountType === 1 && (
                <>{showMenu(userMenu)}</>
              )}
              {loggedIn && user.userDetails?.accountType !== 1 && (
                <>{showMenu(practitionerMenuMobile)}</>
              )}

              {loggedIn && <Divider />}

              {visitorMenu.map((item, idx) => {
                if (!item.submenu) {
                  return (
                    <Button
                      variant="menu"
                      fontSize="sm"
                      colorScheme="tertiary"
                      leftIcon={item.leftIcon ? item.leftIcon : ""}
                      aria-label={item.label}
                      key={idx}
                      onClick={() => {
                        onClose();
                        router.push(item.href);
                      }}
                    >
                      <Text textStyle="body2">{item.label}</Text>
                    </Button>
                  );
                } else if (item.label === "Articles") {
                  return (
                    <>
                      <Button
                        key={idx}
                        variant="menu"
                        fontSize="sm"
                        //colorScheme="secondary"
                        rightIcon={<IconChevronDown />}
                        onClick={() => setArticlesMenu(!articlesMenu)}
                      >
                        <Text textStyle="body2">{item.label}</Text>
                      </Button>
                      {articlesMenu && showMenuOptions(item.submenu)}
                    </>
                  );
                }
                return (
                  <>
                    <Button
                      key={idx}
                      variant="menu"
                      fontSize="sm"
                      //colorScheme="secondary"
                      rightIcon={<IconChevronDown />}
                      onClick={() => setGetHelpMenu(!getHelpMenu)}
                    >
                      <Text textStyle="body2">Read</Text>
                    </Button>
                    {getHelpMenu && showMenuOptions(item.submenu)}
                  </>
                );
              })}
            </VStack>
          </DrawerBody>
          <DrawerFooter borderTopWidth="1px">
            {loggedIn && (
              <>
                {" "}
                <Button variant="outline" mr={3} onClick={() => handleLogout()}>
                  Log Out
                </Button>
              </>
            )}
            {!loggedIn && (
              <>
                <Button
                  variant="outline"
                  mr={3}
                  onClick={() => {
                    onClose();
                    handleClick("login");
                  }}
                >
                  Log in
                </Button>
                <Button
                  onClick={() => {
                    onClose();
                    handleClick("therapist");
                  }}
                >
                  Sign up
                </Button>
              </>
            )}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
};

export default NavBarMobile;
